import { render, staticRenderFns } from "./CarrierPriceModal.vue?vue&type=template&id=698d3dd8&scoped=true"
import script from "./CarrierPriceModal.vue?vue&type=script&lang=js"
export * from "./CarrierPriceModal.vue?vue&type=script&lang=js"
import style0 from "./CarrierPriceModal.vue?vue&type=style&index=0&id=698d3dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698d3dd8",
  null
  
)

export default component.exports